<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-flex sm12 md11 lg8 p-0>
            <v-card class="fill-height">
                <v-breadcrumbs :items="breadCrumbs" class="dense">
                    <template v-slot:divider>
                        <v-icon>forward</v-icon>
                    </template>
                </v-breadcrumbs>

                <v-toolbar flat dense>
                    <v-tooltip
                        bottom
                        :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                @click="loadUsers"
                            >
                                <v-icon>mdi-reload</v-icon>
                                    <span
                                        v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                    >{{ $t("reload") }}</span>
                            </v-btn>
                        </template>
                        <span>{{ $t("reload") }}</span>
                    </v-tooltip>
                    <v-tooltip
                        bottom
                        :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp)"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                v-if="users.length < usersLimit"
                                @click="showNewUserDlg"
                            >
                                <v-icon>mdi-account-plus-outline</v-icon>
                                    <span
                                        v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp)"
                                    >{{ $t("create") }}</span>
                            </v-btn>
                        </template>
                        <span>{{ $t("create") }}</span>
                    </v-tooltip>
                    <v-tooltip
                        bottom
                        :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp)"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                v-if="users.length >= usersLimit"
                                @click="showBlockedNewUserDlg"
                            >
                                <v-icon>mdi-account-plus-outline</v-icon>
                                <span
                                    v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp)"
                                >{{ $t("create") }}</span>
                            </v-btn>
                        </template>
                        <span>{{ $t("create") }}</span>
                    </v-tooltip>
                    <v-tooltip
                        bottom
                        :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.smAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp)"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                :disabled="!selectedRow"
                                @click="editItem(selectedRow)"
                            >
                                <v-icon>mdi-account-edit-outline</v-icon><span
                                    v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.smAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp)"
                                >{{ $t("edit") }}</span>
                            </v-btn>
                        </template>
                        <span>{{ $t("edit") }}</span>
                    </v-tooltip>
                    <v-tooltip
                        bottom
                        :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.smAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp)"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                :disabled="!selectedRow"
                                @click="deleteItemClick(selectedRow)"
                            >
                                <v-icon>mdi-account-remove-outline</v-icon><span
                                    v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.smAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp)"
                                >{{ $t("delete") }}</span>
                            </v-btn>
                        </template>
                        <span>{{ $t("delete") }}</span>
                    </v-tooltip>
                </v-toolbar>


                <v-card-title class="py-0">
                    <v-layout row wrap>
                        <!--
                        <v-flex xs12>
                            <h2>{{ $t("users") }}</h2>
                        </v-flex>
                        -->
                        <v-flex xs6 pr-2>
                            <v-select
                                v-model="companyId"
                                :items="companies"
                                item-text="name"
                                item-value="id"
                                :label="$t('company')"
                                prepend-icon="mdi-office-building-outline"
                            ></v-select>
                        </v-flex>

                        <v-flex xs6 pl-2>
                            <v-text-field
                                v-model="userSearch"
                                append-icon="search"
                                :label="$t('search')"
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-title>

                <v-card-text class="v-scrollable">

                    <v-data-table
                        :rows-per-page-items="rowsPerPageItems"
                        :headers="computedHeaders"
                        :items="filteredUsers"
                        :search="userSearch"
                        class="dense-table"
                    >
                        <template v-slot:items="props">
                            <tr
                                @click="selectedRow = props.item"
                                :class="{'grey darken-5': props.item === selectedRow}"
                            >
                                <td class="text-xs-left">{{ props.item.company }}</td>
                                <td class="text-xs-left">{{ props.item.lastName }}</td>
                                <td class="text-xs-left">{{ props.item.firstName }}</td>
                                <td class="text-xs-left">{{ props.item.middleName }}</td>
                                <td class="text-xs-left">{{ props.item.eMail }}</td>
                                <!--
                                <td class="justify-center layout px-0">
                                    <v-icon
                                        class="mr-2"
                                        @click="editItem(props.item)"
                                    >
                                        edit
                                    </v-icon>
                                    <v-icon
                                        @click="deleteItemClick(props.item)"
                                    >
                                        delete
                                    </v-icon>
                                </td>
                                -->
                            </tr>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{ $t("youSearchFor") }}{{ userSearch }}{{ $t("foundNoResults") }}.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <edit-user-dialog ref="EditUserDialog"/>
            <message-box      ref="MessageBox"/>
            <message-dialog   ref="MessageDialog"/>
        </v-flex>

        <v-alert
            :value="alert !== ''"
            :type="alertType"
            transition="scale-transition"
            class="bottom-alert"
        >
            {{ alert }}
        </v-alert>
    </v-layout>
</template>

<script>
    import MessageBox     from "@/components/dialogs/MessageBox"
    import MessageDialog  from "@/components/dialogs/MessageDialog"
    import EditUserDialog from "@/components/dialogs/EditUserDialog"

    export default {
        name: "UsersManagement",

        components: {
            MessageBox,
            MessageDialog,
            EditUserDialog
        },

        data () {
            return {
                alert: "",
                alertType: "success",
                breadCrumbs: [
                    { text: "Администрирование", disabled: false },
                    { text: "Пользователи",      disbaled: false }
                ],
                headers: [
                    { text: "id",          value: "id",         align: "center", sortable: true },
                    { text: "Организация", value: "company",    align: "left",   sortable: true },
                    { text: "Фамилия",     value: "lastName",   align: "left",   sortable: true },
                    { text: "Имя",         value: "firstName",  align: "left",   sortable: true },
                    { text: "Отчество",    value: "middleName", align: "left",   sortable: true },
                    { text: "E-Mail",      value: "eMail",      align: "left",   sortable: true } //,
                    //{ text: "Действие",    value: "action",     align: "center", sortable: false }
                ],

                loading: {
                    companies: false,
                    users:     false
                },

                hideIDs: true,
                rowsPerPageItems: [25,50,75,95],
                //progressBarVisible: false,
                selectedRow: null,
                companies: [],
                companyId: 0,
                users: [],
                usersLimit: 1,
                userSearch: "",

                dialogWatcher: null,
                userWatcher: null
            }
        },

        computed: {
            computedHeaders () {
                if (this.hideIDs) {
                    return this.headers.filter(header => header.text !== "id");
                }

                return this.headers;
            },

            filteredUsers() {
                return this.companyId == 0
                    ? this.users
                    : this.users.filter(user => user.companyId == this.companyId);
            },

            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },

            progressBarVisible () {
                return this.loading.companies || this.loading.users;
            }
        },

        watch: {
            alert: function (val) {
                let component = this;
                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            },
        },

        mounted () {
            // user roles: 1 - user, 2 - manager, 3 - admin
            if (!this.$store.getters.user.loggedIn || this.$store.getters.user.role < 2) {
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            this.usersLimit = this.$store.getters.subscription.limits.maxUsers
                ? this.$store.getters.subscription.limits.maxUsers
                : 1;

            this.applyLocale();
            this.loadCompanies();
            this.loadUsers();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.headers = [
                    { text: "id",                  value: "id",         align: "center", sortable: true },
                    { text: this.$t("company"),    value: "company",    align: "left",   sortable: true },
                    { text: this.$t("lastName"),   value: "lastName",   align: "left",   sortable: true },
                    { text: this.$t("firstName"),  value: "firstName",  align: "left",   sortable: true },
                    { text: this.$t("middleName"), value: "middleName", align: "left",   sortable: true },
                    { text: this.$t("eMail"),      value: "eMail",      align: "left",   sortable: true } //,
                    //{ text: this.$t("action"),     value: "action",     align: "center", sortable: false }
                ];

                this.breadCrumbs = [
                    { text: this.$t("administration"), disabled: false },
                    { text: this.$t("users"),          disabled: false }
                ];
            },

            /**
             * Удаление пользователя
             *
             * @param {object} item Данные удаляемого пользователя
             */
            deleteItem (item) {
                this.axios({
                    method: "delete",
                    url: `${this.$config.apiURL}users/${item.id}/`,
                    withCredentials: true
                }).then(() => {
                    this.loadUsers();
                }).catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) {
                            this.dialogWatcher();
                        }

                        /* Отслеживание ответа в диалоге "Да/Нет" */
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteUser") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteUser") + ". " + this.$t("accessDenied"));
                    } else {

                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteUser"));
                    }
                });
            },

            /**
             * Обработчик нажатия кнопки удаления пользователя
             *
             * @param {object} item Данные удаляемого пользователя
             */
            deleteItemClick (item) {
                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.MessageDialog.answer",
                    (val) => {
                        if (val) { this.deleteItem(item); }
                    }
                );

                this.$refs.MessageDialog.title       = this.$t("userDelete");
                this.$refs.MessageDialog.messageText = this.$t("confirmUserDelete");
                this.$refs.MessageDialog.dialog      = true;
            },

            /**
             * Редактирование пользователя
             *
             * @param {object} item Данные удаляемого пользователя
             */
            editItem (item) {
                this.initUserWatcher();
                this.$refs.EditUserDialog.resetForm();
                this.$refs.EditUserDialog.userId     = item.id;
                this.$refs.EditUserDialog.imageUrl   = item.avatar;
                this.$refs.EditUserDialog.eMail      = item.eMail;
                this.$refs.EditUserDialog.firstName  = item.firstName;
                this.$refs.EditUserDialog.middleName = item.middleName;
                this.$refs.EditUserDialog.lastName   = item.lastName;
                this.$refs.EditUserDialog.company    = item.company;
                this.$refs.EditUserDialog.password1  = "";
                this.$refs.EditUserDialog.password2  = "";
                this.$refs.EditUserDialog.dialog     = true;
            },

            /**
             * Инициализация наблюдателя за изменением данных пользователя
             */
            initUserWatcher () {
                if (this.userWatcher !== null) {
                    this.userWatcher();
                }

                /* Отслеживание изменения флага изменения данных */
                this.userWatcher = this.$watch(
                    "$refs.EditUserDialog.dataUpdated",
                    (val) => {
                        if (val) {
                            this.loadUsers();
                            this.$emit("usersUpdated", true);
                            this.alertType = "success";
                            this.alert     = this.$t("userUpdated");
                        }
                    }
                );
            },

            /**
             * Загрузка списка компаний
             */
            loadCompanies () {
                this.loading.companies = true;

                this.axios.get(
                    this.$store.getters.user.role == 3 ? `${this.$config.apiURL}companies/` : `${this.$config.apiURL}companies/${this.$store.getters.user.company.id}/`,
                    { withCredentials: true }
                ).then(response => {
                    if (response.data.status == "success") {
                        let companiesInfo = response.data.companies == undefined ? [response.data.company] : response.data.companies;

                        this.companies = [];

                        companiesInfo.forEach((company) => {
                            this.companies.push({
                                id:   company.id,
                                name: company.Name,
                            });

                            if (this.$store.getters.user.role < 3) {
                                this.companyId = company.id;
                            }
                        });
                    }

                    this.companies.sort((a, b) => {
                        return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
                    });

                    this.companies.unshift({
                        id:   0,
                        name: this.$t("all")
                    });

                    this.loading.companies = false;
                })
                .catch(err => {
                    this.loading.companies = false;

                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `UsersManagement.vue -> loadCompanies: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    });

                    if (err.response && err.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (err.response && err.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUserData") + ". " + this.$t("subscriptionExpired"));
                    } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (err.response && err.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUsersData") + ". " + this.$t("accessDenied"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadCompaniesData"));
                    }
                });
            },

            /**
             * Загрузка списка пользователей
             */
            loadUsers () {
                this.loading.users = true;

                this.axios.get(`${this.$config.apiURL}users/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let usersInfo = response.data.users

                            this.users    = [];

                            usersInfo.forEach((user) => {
                                this.users.push({
                                    id:         user.id,
                                    companyId:  user.Company.id,
                                    company:    user.Company.Name,
                                    firstName:  user.FirstName,
                                    middleName: user.MiddleName,
                                    lastName:   user.LastName,
                                    eMail:      user.EMail,
                                    avatar:     `${this.$config.apiURL}users/${user.id}/avatar/`
                                });
                            });
                        }

                        this.loading.users = false;
                    })
                    .catch(err => {
                        this.loading.users = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `UsersManagement.vue -> loadUsers: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadUsersData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadUsersData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadUsersData"));
                        }
                    });
            },

            /**
             * Отображение сообщения о превышении лимита учётных записей пользователей
             */
            showBlockedNewUserDlg () {
                if (this.users.length >= this.usersLimit) {
                    this.showMessageBox(this.$t("attention"), this.$t("createUsersLimitReachedMessage"));
                }
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             * Отображение диалога создания новой учётной записи
             */
            showNewUserDlg () {
                this.initUserWatcher();
                this.$refs.EditUserDialog.resetForm();
                this.$refs.EditUserDialog.dialog = true;
            }
        }
    }
</script>

<style lang="sass" scoped>
    .layout.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100dvh - 176px)
</style>
